import { Component } from "./Component";
import { vp } from "../managers/vp";
import { ProjectDomUtils } from "../libs/utils/ProjectDomUtils";
export class TopHeader extends Component {
    init() {
        this._menuHtml = this.getHtml('menu');
        this._moreButtonHtml = this.getHtml('more_button');
        switch (window.location.pathname) {
            case "/":
                this._menuHtml.firstElementChild.setAttribute('data-chosen', 'true');
                break;
        }
        vp.components.forEach({ id: 'SideMenu-main' }, (sideMenu) => {
            this._sideMenu = sideMenu;
            this._menuHtml.firstElementChild.addEventListener('click', () => {
                window.location.href = '/';
            });
        }, true);
        this._moreButtonHtml.addEventListener('click', (event) => {
            if (event.target != this._moreButtonHtml)
                return;
            this._morePressed = !this._morePressed;
            this._moreButtonHtml.firstElementChild.hidden = this._morePressed;
            this._moreButtonHtml.children[1].hidden = !this._morePressed;
            const options = this._moreButtonHtml.lastElementChild;
            options.setAttribute("data-show", this._morePressed ? "true" : "false");
        });
        this.getHtml('logo').addEventListener('click', () => {
            window.location.href = '/';
        });
    }
    update() {
        const scrollingElement = ProjectDomUtils.getScrollElement();
        if (scrollingElement.scrollTop > 20) {
            this.html.setAttribute('data-on_top', 'true');
        }
        else {
            this.html.setAttribute('data-on_top', 'false');
        }
    }
}
